import { UpdateAssessmentMutationProvider } from "__legacy/queries/projects/UpdateAssessmentMutationProvider";
import { Button, Card, Col, Drawer, Form, Row } from "antd";
import { Fragment, useState } from "react";
import { useParams } from "react-router";

import { onFinish, PwsAssessmentForm } from "./PwsAssessmentForm";

type PwsAssessmentCardType = {
  project: any;
  editable: boolean;
};

export const PwsAssessmentCard: React.FC<PwsAssessmentCardType> = (props) => {
  const { project, editable } = props;
  const { id } = useParams();
  const title = "Assessment";
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  const [drawerVisible, setDrawerVisible] = useState(false);
  const onClose = () => setDrawerVisible(false);

  const [Mutation, params, variables] = [UpdateAssessmentMutationProvider, {}, { id }];

  const onError = () => ({ graphQLErrors }: any) => {
    const errors: string[] = [];
    graphQLErrors.forEach((graphQLError: any) => {
      errors.push(graphQLError.message);
    });
    setErrors(errors);
  };

  const filled = project.assessmentFilled;

  return (
    <Fragment>
      <Card
        title={title}
        bodyStyle={filled ? {} : { display: "none" }}
        extra={
          editable && (
            <Button type={filled ? "ghost" : "primary"} onClick={() => setDrawerVisible(true)}>
              {filled ? "Edit" : "Fill"}
            </Button>
          )
        }
      >
        <Row gutter={[24, 24]}>
          <Col span={12}>Stage 1 {project.initialAssessmentOffsite ? "Off" : "On"} Site</Col>
          {project.initialAssessmentOffsite && (
            <Col span={12}>
              Reason: <b>{project.initialAssessmentReason}</b>
            </Col>
          )}
        </Row>
      </Card>
      <Mutation onError={onError}>
        {(loading, mutate) => (
          <Drawer
            title={title}
            width={680}
            onClose={onClose}
            visible={drawerVisible}
            keyboard={false}
            maskClosable={false}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button onClick={onClose} style={{ marginRight: 8 }}>
                  Cancel
                </Button>
                <Button type="primary" loading={loading} onClick={() => form.submit()}>
                  Save
                </Button>
              </div>
            }
          >
            <PwsAssessmentForm
              form={form}
              project={project}
              onFinish={onFinish(mutate, params, variables)}
              errors={errors}
            />
          </Drawer>
        )}
      </Mutation>
    </Fragment>
  );
};
